import { Typography } from "antd"
import { getDateString } from "utils/date"
import { CreatedAt } from "types/api"

type DateValue = string | CreatedAt

export const DateCell = ({ value }: { value: DateValue }) => {
    // Если значение - это объект с форматом CreatedAt
    const dateString = typeof value === "object" && value?.date 
        ? value.date 
        : value as string

    const parsedValue = getDateString(dateString, "YYYY-MM-DD HH:mm")
    return <Typography.Text>{parsedValue}</Typography.Text>
}
